import { render, staticRenderFns } from "./ChatItemLote.vue?vue&type=template&id=452b9dbe&scoped=true"
import script from "./ChatItemLote.vue?vue&type=script&lang=js"
export * from "./ChatItemLote.vue?vue&type=script&lang=js"
import style0 from "./ChatItemLote.vue?vue&type=style&index=0&id=452b9dbe&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b9dbe",
  null
  
)

export default component.exports